const DISMISSED_PREFIX = "vianbills_login_announcement_dismissed:";

export function announcementDismissalKey(userId, announcementId) {
  return `${DISMISSED_PREFIX}${userId}:${announcementId}`;
}

export function isAnnouncementDismissed(userId, announcementId) {
  return Boolean(sessionStorage.getItem(announcementDismissalKey(userId, announcementId)));
}

export function dismissAnnouncement(userId, announcementId) {
  sessionStorage.setItem(announcementDismissalKey(userId, announcementId), "1");
}

export function clearAnnouncementDismissals() {
  for (let i = sessionStorage.length - 1; i >= 0; i -= 1) {
    const key = sessionStorage.key(i);
    if (key?.startsWith(DISMISSED_PREFIX)) sessionStorage.removeItem(key);
  }
}
